<div>
  <div id="loading_moneybox">
    <div class="loading content_loading" style="background: white !important; opacity:1 !important">
      <div class="animation6">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="checkbox != null">
    <div class="row content__grid">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="page-title-box">
          <div class="row align-items-center">
            <div class="col-sm-6 col-md-6 col-sm-6 col-12">
              <h4 class="page-title content__title">Control de caja
                <ng-container *ngIf="moneybox != null">
                  - <span class="f-s-11 text-primary">{{moneybox.nro_voucher}}</span>
                </ng-container>
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 text-right">
              <div class="content__subhead__inputGrid">
                <div class="input-group">
                  <span class="input-group-prepend"><span
                      class="input-group-text content__subhead__inputGrid__title">Caja seleccionada</span></span>
                  <select id="boxSelected" [(ngModel)]="boxselected" (change)="changeBoxselected()"
                    class="form-control content__subhead__inputGrid__input">
                    <option *ngFor="let item of branchboxes" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="row">
          <div class="col-lg-5">
            <div class="card m-b-30">
              <div class="card-header money__opening__principal__header">
                <span class="bold">Fecha: {{date_now}}</span>
                <span class="float-right">
                  <i class="fas fa-user m-r-2"></i> <span class="bold">Usuario</span>, {{user.name}}
                </span>
              </div>
              <ng-container *ngIf="check_moneybox">
                <div *ngIf="moneybox != null">
                  <div class="card-body money__opening__principal__card">
                    <span *ngIf="moneybox.status_closed == false"
                      class="badge badge-primary money__opening__principal__info">Caja abierta</span>
                    <span *ngIf="moneybox.status_closed == true"
                      class="badge badge-danger money__opening__principal__info">Caja cerrada</span>
                    <ng-container *ngIf="moneybox.is_before">
                      <span class="badge badge-warning money__opening__principal__info f-s-14"
                        ng-if="moneybox.is_before">CAJA ANTERIOR : {{moneybox.date_opening}}</span>
                    </ng-container>
                    <p class="card-text money__opening__principal__price">
                      {{moneybox.balance}}
                    </p>
                  </div>
                  <div class="card-footer text-muted money__opening__principal__footer">
                    <div class="row">
                      <div class="col-lg-5 p-5">
                        <p class="money__opening__principal__footer__initial">Caja inicial
                          {{moneybox.amount_opening}}
                        </p>
                      </div>
                      <div class="col-lg-7 p-5 text-right">
                        <a *ngIf="moneybox.status_closed == false" (click)="closeBox()"
                          class="btn btn-danger btn-sm text-white pointer m-r-5">
                          <i class="fas fa-lock m-r-5"></i> Cerrar caja
                        </a>
                        <div class="btn-group btn-group-sm inline-group">
                          <button type="button" class="btn btn-success btn-sm text-white dropdown-toggle"
                            data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
                            <i class="fas fa-download"></i> Arqueo
                          </button>
                          <div class="dropdown-menu">
                            <a class="dropdown-item f-s-12"
                              href="/{{branchofficeSlug}}/api/report/money/arqueo/{{moneybox.id}}/ticket"
                              target="_blank">Ticket</a>
                            <a class="dropdown-item f-s-12"
                              href="/{{branchofficeSlug}}/api/report/money/arqueo/{{moneybox.id}}/a4"
                              target="_blank">Formato A4</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!check_moneybox">
                <div>
                  <ng-container *ngIf="!is_open">
                    <div class="card-body money__opening__principal__cardEmpty">
                      <i class="fas fa-kaaba text-center f-s-60 m-t-30"></i>
                      <p class="m-t-10">Aún no tiene abierto la caja para la fecha actual</p>
                      <a class="btn btn-primary btn-sm text-white pointer"
                        (click)="is_open = ! is_open; setFocusAmountOpening()">
                        <i class="fas fa-lock-open m-r-5"></i> Abrir caja
                      </a>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="is_open">
                    <div>
                      <div class="d-flex justify-content-center m-t-15">
                        <div style="width: 50%">
                          <p class="f-s-16 text-center bold">Apertura de caja <i class="fas fa-lock-open m-l-5"></i></p>
                          <div class="form-group p-l-20 p-r-20">
                            <label>Monto inicial</label>
                            <div class="input-group">
                              <div class="input-group-prepend"><span class="input-group-text">S/</span>
                              </div>
                              <input type="text" id="amount_opening" numeric decimals="2" onclick="click_input(this)"
                                [(ngModel)]="amount_opening" class="form-control bold f-s-16">
                            </div>
                          </div>
                          <div class="form-group m-t-20 m-b-50 text-center">
                            <a type="button" class="btn btn-secondary text-white m-r-5"
                              (click)="is_open = ! is_open">Cancelar</a>
                            <button type="button" class="btn btn-primary waves-effect waves-light text-white"
                              (click)="openBox()"> <i class="far fa-save m-r-5"></i> Aperturar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>


                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="row">
              <ng-container *ngIf="summary_paymethods.length > 0">
                <div class="col-lg-6" *ngFor="let item of summary_paymethods; let index_ = index">
                  <div class="card">
                    <div class="card-heading money__opening__badge__card">
                      <div class="mini-stat-icon float-right">
                        <i class="{{item.icon}} {{item.bg_color}} text-white money__opening__badge__icon"></i>
                      </div>
                      <div>
                        <h5 class="font-16">{{item.description}}</h5>
                      </div>
                      <h3 class="money__opening__badge__money">{{item.total}}</h3>
                      <p class="text-muted mt-2 mb-0">N° transacciones<span
                          class="float-right">{{item.transactions}}</span></p>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="checkbox == null">
    <div class="col-12 d-flex justify-content-center m-t-100">
      <div class="card" style="width: 30%">
        <div class="card-header">
          <div class="m-t-20 text-center">
            <i class="fas fa-archive f-s-50 text-dark"></i>
            <p class="bold m-t-15 f-s-18">Seleccione caja para aperturar</p>
          </div>
        </div>
        <div class="card-body">
          <div class="form-group">
            <select id="boxSelected" [(ngModel)]="boxselected" class="form-control">
              <option *ngFor="let item of branchboxes" [value]="item.id">{{ item.description }}</option>
            </select>
          </div>
          <div class="form-group d-flex justify-center m-t-30">
            <button type="button" class="btn btn-secondary waves-effect m-r-10">Cancelar</button>
            <button type="button" (click)="selectBoxselected()" class="btn btn-primary waves-effect waves-light">
              Seleccionar caja
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
